import { StepSubtitleProps } from './StepSubtitle.types';
import * as S from './StepSubtitle.styles';

const StepSubtitle = (props: StepSubtitleProps): JSX.Element => <S.Container {...props} />;

export default StepSubtitle;
